import React from 'react'
import { FormControl, InputLabel, ListItemIcon, MenuItem, Select as MuiSelect, SelectChangeEvent } from '@mui/material'

import { Icon } from './icon.tsx'

export interface SelectProps<Value> {
  items: Array<{ value: Value; label: string }>
  label: string
  labelId: string
  onChange(event: SelectChangeEvent<Value>): void
  value: Value
}

export const Select = <Value,>({ labelId, items, value, onChange, label }: SelectProps<Value>): React.ReactElement => {
  return (
    <FormControl fullWidth>
      <InputLabel id={labelId}>{label}</InputLabel>
      <MuiSelect value={value} onChange={onChange} labelId={labelId}>
        {items.map((item) => (
          <MenuItem
            // @ts-expect-error comment: скорее всего всегда будут строки/числа в значениях
            key={item.value}
            value={item.value}
          >
            {item.label}
            {value === item.value && (
              <ListItemIcon sx={{ color: 'text.primary' }}>
                <Icon name="Check" />
              </ListItemIcon>
            )}
          </MenuItem>
        ))}
      </MuiSelect>
    </FormControl>
  )
}
